<template>
  <v-app v-resize="updateWindowHeight">
    <div :class="{ 'is-blurred': modalOpen || showModal }" class="app-content">
      <router-view />
    </div>
    <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      bottom
    >
      <div class="black--text text-center w-100">
        {{ snackbar.message }}
      </div>
    </v-snackbar>
    <settings-modal @input="coreStore.handleSettingsModal" :value="modalOpen" />
      <!-- A lupa procura aplicacoes, e no /login nao ha nenhuma para procurar.
           O clique ja era ignorado la, mas o botao continuava desenhado por
           cima do painel; some de vez. `naLogin` e a mesma resposta que o
           atalho Ctrl+F usa, para os dois nao divergirem. -->
      <v-tooltip v-if="!naLogin" top>
        <template v-slot:activator="{ on, attrs }">
          <liquid-glass-effect class="search-icon-modal" width="35px" height="35px" border-radius="50%" :blur="0.006" :displacement=".120">
            <v-btn v-on="on" v-bind="attrs" @click="showModal = true" icon outlined>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </liquid-glass-effect>
        </template>
        {{ $t('extras.ctrlF') }}
      </v-tooltip>
      <div>
        <the-search-spot-light v-model="showModal" />
      </div>
      <div>
        <the-request-demo-modal v-model="coreStore.requestDemo" />
      </div>
      <route-transition-overlay />
  </v-app>
</template>

<script>
import { mapState, mapStores, mapWritableState } from "pinia";
import { useDisplayStore } from "./store/portfolioStore";
import SettingsModal from "./components/modal/SettingsModal.vue";
import RouteTransitionOverlay from "./components/common/RouteTransitionOverlay.vue";
import { useCoreStore } from "./store/coreStore";
import { useAnalyticsProStore } from "./store/analyticsStore";
import TheSearchSpotLight from "./components/modal/TheSearchSpotLight.vue";
import TheRequestDemoModal from "./components/modal/TheRequestDemoModal.vue";
import { useSnackbarStore } from "./store";
import LiquidGlassEffect from "./components/layout/ui/LiquidGlassEffect.vue";

export default {
  components: {
    SettingsModal,
    TheSearchSpotLight,
    TheRequestDemoModal,
    LiquidGlassEffect,
    RouteTransitionOverlay,
  },
  watch: {
    breakpoint: {
      handler(newValue) {
        this.setBreakpoint(newValue);
      },
    },
  },
  mounted() {
    this.setBreakpoint(this.breakpoint);
    window.addEventListener('keydown', this.openViaKeys)
  },
  data() {
    return {
      showModal: false,
      tab: 0,
      menus: [
        //{ label: "API Documentation", to: "/api-doc", disabled: true  },
        //{ label: "API Test in-place", to: "/api-sandbox", disabled: true  },
        //{ label: "Monitoring (TBR)", disabled: true },
        //{ label: "IP Allowlist (TBR)", disabled: true },
        //{ label: "Session (TBR)", disabled: true },
        //{ label: "Notifications (TBR)", disabled: true }
      ],
      panel: undefined,
    };
  },
  computed: {
    snackbar() {
      return useSnackbarStore()
    },
    ...mapStores(useCoreStore),
    ...mapStores(useAnalyticsProStore),
    ...mapWritableState(useDisplayStore, {
      breakpointState: "breakpoint",
      windowHeightState: "windowHeight",
    }),

    ...mapState(useDisplayStore, [
      "isXSmall",
      "isSmall",
      "isMedium",
      "isLarge",
      "isXLarge",
    ]),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    modalOpen() { return this.coreStore.getSettingsModal },
    naLogin() { return this.$route.path === '/login' },
  },
  methods: {
    setBreakpoint(value) {
      this.breakpointState = value;
    },
    updateWindowHeight() {
      this.windowHeightState = window.innerHeight;
    },
    openViaKeys(e) {
      if (this.naLogin) return
      if (!(e.ctrlKey || e.metaKey)) return;

      const key = e.key.toLowerCase()
      const actions = {
        f: () => {
          this.showModal = true;
        },
        " ": () => {
          this.showModal = true;
        },
        s: () => {
          this.coreStore.settingsModal = true;
        },
        y: () => {
          this.analyticsProStore.toggleDatasetPersistence();
        }
      }

      if (actions[key]) {
        e.preventDefault();
        actions[key]()
      }

    }
  },
};
</script>
<style>
:root {
  --bg: #0e0f12;
  --surface: #15171c;
  --surface-2: #1b1e24;
  --border: #2a2e36;
  --muted: #9aa3af;
  --text: #e6e7ea;
  --text-soft: #c7c9ce;
  --accent: #ff8a3d; /* laranja do item ativo */
  --success: #26c281;
  --danger: #e55353;
  --main-color: #ffbf00;
  --ink: #0b0d0c;
  --ink2: #131615;
  --ink3: #1c201e;
  --line: #2a2f2c;
  --paper: #f3efe6;
  --dim: #c9c3b3;
  --muted: #8a857a;
  --hot: #ff4d1f;
  --cool: #7bc4a4;
  --warn: #e8b64a;
}

.app-content {
  transition: filter .3s ease;
}

.app-content.is-blurred {
  filter: blur(0px);
}

.search-icon-modal {
  display: flex;
  position: fixed;
  z-index: 100000;
  right: 1.5rem;
  bottom: 4%;
  background: rgba(239, 239, 239, 0.1);
  place-items: center;
}

.blur-background {
  filter: blur(15px) !important;
}

.app-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.v-application {
  display: flex;
  margin: auto;
  flex-direction: column;
  scrollbar-width: none;
  height: 100vh;

}
.light-input-text{
  font-weight: 300;
  font-size: 0.75rem;
  line-height: 1.25rem;
  letter-spacing: 0.03em;
    white-space: nowrap;

}
.dash {
 /* background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgb(17, 17, 17) 80%);*/
  height: 100vh;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
}

.v-card {
  background-color: #15171c !important;
  border: 1px solid rgb(33, 31, 25);
  padding: 1.5rem;
}

.table,
.v-data-table {
  background: none !important;
}
.copy-icon {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.copy-icon:hover{
  opacity: 1;
}
router-view {
  flex: 1;
}
</style>
